class paths {
  static login = "/login";
  static register = "/register";
  static home = "/goals";
  static settings = "/settings";
}

export default paths;
